<template>
  <!-- 会员主题 -->
  <div class="headConfig">
    <h4 class="describe">会员主题</h4>
    <div class="configWrap">
      <!-- 卡面列表 -->
      <div class="cardList">
        <h6 class="tips">卡面</h6>
        <p class="careful">会员卡卡面尺寸750*320px，如需自定义背景请上传该尺寸图片</p>
        <img :src="pageConfig.menberPage.currentCrad.card" class="curCardImg" alt="" />
        <!-- <div class="curCardImg"></div> -->
        <!-- 卡面列表 -->
        <div class="scroll">
          <i class="iconfont prev" :class="{ disabled: !disabledPrev }" @click="cardChange('prev')">&#xe698;</i>
          <div class="hidden">
            <ul class="list" ref="list" :style="{ left: cardScrollLeft + 'px' }">
              <div class="item first" @click="handleCustom(true)">
                <div class="card"><i class="iconfont">&#xe697;</i></div>
                <span>自定义</span>
              </div>
              <div
                v-for="(item, index) in pageConfig.menberPage.cradList"
                class="item"
                :key="'crad' + index"
                @click="switchCradBg({ imageUrl: item.imageUrl, id: item.id })"
              >
                <img class="card" :class="{ active: item.id == pageConfig.menberPage.currentCrad.id }" :src="item.imageUrl" alt="" />
                <span>{{ item.name }}</span>
              </div>
            </ul>
          </div>
          <i class="iconfont next" :class="{ disabled: !disabledNext }" @click="cardChange('next')">&#xe69d;</i>
        </div>
      </div>
      <!-- 文字颜色设置 -->
      <div class="textSet">
        <h6 class="tips">文字</h6>
        <p class="careful">可以根据选择的背景自由设置适配的文字颜色</p>
        <div class="colorBox">
          <div class="color" :style="{ 'background-color': textColor }"></div>
          <i class="el-icon-arrow-down"></i>
          <el-color-picker v-model="textColor" @active-change="setClorChange" size="mini" class="colorPicker"> </el-color-picker>
        </div>
      </div>
      <!-- 文字背景颜色设置 -->
      <div class="textSet">
        <h6 class="tips">文字背景</h6>
        <p class="careful">可以根据选择的背景自由设置适配的文字背景颜色</p>
        <div class="colorBox">
          <div class="color" :style="{ 'background-color': textBgColor }"></div>
          <i class="el-icon-arrow-down"></i>
          <el-color-picker v-model="textBgColor" color-format="hex" @active-change="setClorChange($event, 1)" size="mini" class="colorPicker">
          </el-color-picker>
        </div>
      </div>
      <!-- 背景设置 -->
      <div class="backgroundSet">
        <h6 class="tips">背景</h6>
        <p class="careful">背景图的尺寸为750*276px，可自定义背景图</p>
        <!-- 背景列表 -->
        <div class="scroll">
          <i class="iconfont prev" :class="{ disabled: !prev }" @click="backgroundChange('prev')">&#xe698;</i>
          <div class="hidden">
            <ul class="list" ref="bgList" :style="{ left: bgScrollLeft + 'px' }">
              <div class="item first" @click="handleCustom(false)">
                <div class="card"><i class="iconfont">&#xe697;</i></div>
                <span>自定义</span>
              </div>
              <template v-for="item in pageConfig.menberPage.bgImageList">
                <div class="item" :key="item.id" @click="switchBgImage({ imageUrl: item.imageUrl, id: item.id })">
                  <img :src="item.imageUrl" class="card" :class="{ active: pageConfig.menberPage.currentImage.id == item.id }" />
                  <!-- <div class="card"></div> -->
                  <span>{{ item.name }}</span>
                </div>
              </template>
            </ul>
          </div>
          <i class="iconfont next" :class="{ disabled: !next }" @click="backgroundChange('next')">&#xe69d;</i>
        </div>
      </div>
    </div>

    <!-- 图片管理 -->
    <PhotoGallery 
        :showLite = '1'
        :isShow="photoGalleryVisible" 
        @close="photoGalleryChange"
        ></PhotoGallery>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import PhotoGallery from "@/components/PhotoGallery";

export default {
  props: {},
  components: {
    PhotoGallery,
  },
  data() {
    return {
      listWidth: null,
      cardScrollLeft: 0,
      // 是否可翻页控制
      disabledPrev: false,
      disabledNext: false,
      maxCardScorllLeft: null,
      // 字体颜色
      textColor: "#4F3407",
      // 字体背景颜色
      textBgColor: "#ffffff",
      // 背景列表
      bgListWidth: null,
      bgScrollLeft: 0,
      maxBgScorllLeft: null,
      prev: false,
      next: false,
      // 图片管理状态控制
      photoGalleryVisible: false,
      // 用于判断是从那个自定义入口进去的
      customState: null,
    };
  },
  computed: {
    ...mapState(["pageConfig"]),
  },
  mounted() {
    this.initScroll();
  },
  methods: {
    ...mapMutations(["switchCradBg", "switchColor", "switchBgImage"]),
    // 初始化滚动状态
    initScroll() {
      this.listWidth = this.$refs.list.offsetWidth;
      this.bgListWidth = this.$refs.bgList.offsetWidth;
      const cardNum = Math.ceil(this.$refs.list.children.length / 3);
      const bgNum = Math.ceil(this.$refs.list.children.length / 3);
      if (cardNum > 1) {
        this.disabledNext = true;
        this.maxCardScorllLeft = (bgNum - 1) * this.listWidth;
      }
      if (bgNum > 1) {
        this.next = true;
        this.maxBgScorllLeft = (bgNum - 1) * this.bgListWidth;
      }
    },
    // 卡片翻页
    cardChange(type) {
      if (type === "prev") {
        // 左滑
        if (this.disabledPrev) {
          this.cardScrollLeft -= -this.listWidth;
          if (Math.abs(this.cardScrollLeft) <= this.maxCardScorllLeft) {
            this.disabledPrev = false;
            this.disabledNext = true;
          }
        }
      } else {
        // 右滑
        if (this.disabledNext) {
          this.cardScrollLeft += -this.listWidth;
          if (Math.abs(this.cardScrollLeft) >= this.maxCardScorllLeft) {
            this.disabledPrev = true;
            this.disabledNext = false;
          }
        }
      }
    },
    backgroundChange(type) {
      if (type === "prev") {
        // 左滑
        if (this.prev) {
          this.bgScrollLeft -= -this.bgListWidth;
          if (Math.abs(this.bgScrollLeft) <= this.maxBgScorllLeft) {
            this.prev = false;
            this.next = true;
          }
        }
      } else {
        // 右滑
        if (this.next) {
          this.bgScrollLeft += -this.bgListWidth;
          if (Math.abs(this.bgScrollLeft) >= this.maxBgScorllLeft) {
            this.prev = true;
            this.next = false;
          }
        }
      }
    },
    setClorChange(color, state) {
      const reg = /[0-9]\d+/g;
      const getArr = color.match(reg);
      let hex = "#" + ((getArr[0] << 16) | (getArr[1] << 8) | getArr[2]).toString(16);
      if (state) {
        this.textBgColor = hex;
        this.switchColor({ color: hex, choice: true });
      } else {
        this.textColor = hex;
        this.switchColor({ color: hex, choice: false });
      }
    },
    // 点击上传自定义
    handleCustom(state) {
      this.customState = state;
      this.photoGalleryVisible = true;
    },
    // 接收图片库外传URL
    photoGalleryChange(data) {
      this.photoGalleryVisible = false;
      if (data) {
        // 有返回图片的情况下
        this.customState ? this.switchCradBg(data) : this.switchBgImage(data);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.headConfig {
  height: 100%;
  overflow: scroll;
  &.centerMove-enter-active {
    transition: all 1s;
    &::-webkit-scrollbar-thumb {
      background: #ddd;
    }
  }
  &::-webkit-scrollbar {
    width: 6px;
    height: 10px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(246, 246, 246, 1);
    border-radius: 2px;
  }
  &::-webkit-scrollbar-thumb {
    background: #f5f7fa;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #ddd;
  }
  .describe {
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    padding-left: 28px;
    margin: 0;
    text-align: left;
    height: 64px;
    background-color: #f5f5f5;
    color: #333;
    font-size: 16px;
    font-weight: 500;
    .desc {
      margin-top: 5px;
      color: #999;
      font-size: 14px;
      font-weight: 400;
    }
  }
  .configWrap {
    box-sizing: border-box;
    padding: 20px 0;
    text-align: left;
    .tips {
      position: relative;
      display: inline-block;
      color: #333;
      font-size: 14px;
      font-weight: 500;
      &::after {
        content: "*";
        position: absolute;
        right: -8px;
        top: 2px;
        color: #ff3a27;
      }
    }
    .careful {
      margin: 6px 0 20px 0;
      color: #333;
      font-size: 14px;
      font-weight: 400;
    }
    .cardList {
      box-sizing: border-box;
      padding: 0 28px 20px;
      border-bottom: 1px solid #f3f3f3;
      .curCardImg {
        width: 100%;
        height: 243px;
        // background: linear-gradient(133deg, #F3D59F 0%, #D5AA6B 100%);
        box-shadow: 0px 0px 20px rgba(181, 181, 181, 0.5);
        border-radius: 12px;
      }
    }
    .textSet {
      box-sizing: border-box;
      padding: 20px 28px;
      border-bottom: 1px solid #f3f3f3;
      .colorBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        box-sizing: border-box;
        padding: 0 8px;
        width: 222px;
        height: 32px;
        border: 1px solid rgba(0, 0, 0, 0.14901960784313725);
        border-radius: 3px;
        .color {
          width: 172px;
          height: 20px;
          border-radius: 2px;
          border: 1px solid #cccccc;
        }
        i {
          cursor: pointer;
        }
        .colorPicker {
          position: absolute;
          right: 0;
          top: 0;
          opacity: 0;
        }
      }
    }
    .backgroundSet {
      box-sizing: border-box;
      padding: 20px 28px;
      border-bottom: 1px solid #f3f3f3;
    }
    .scroll {
      display: flex;
      align-items: center;
      margin-top: 28px;
      height: 92px;
      .prev {
        width: 10px;
        height: 18px;
        color: #999;
        margin: 0 12px 18px 0;
        cursor: pointer;
      }
      .next {
        width: 10px;
        height: 18px;
        color: #999;
        margin: 0 0 18px 12px;
        cursor: pointer;
      }
      .disabled {
        color: #ccc !important;
      }
      .hidden {
        position: relative;
        height: 100%;
        flex: 1;
        overflow: hidden;
        .list {
          display: flex;
          align-items: center;
          position: absolute;
          width: 100%;
          height: 65%;
          transition: all 0.3s linear;
          .item {
            box-sizing: border-box;
            position: relative;
            height: 100%;
            margin-right: 8px;
            &.last,
            &.first {
              .card {
                i {
                  width: 15px;
                  height: 15px;
                  color: #999;
                }
                box-shadow: none;
                border: 1px dashed #ccc;
              }
            }
            &:last-child {
              margin: 0;
            }
            .card {
              display: flex;
              align-items: center;
              justify-content: center;
              box-sizing: border-box;
              width: 120px;
              height: 100%;
              border-radius: 4px;
              box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
              cursor: pointer;
              transition: all 0.2s;
              &.active {
                border: 1px solid #7b61ff;
              }
            }
            span {
              position: absolute;
              left: 50%;
              bottom: -25px;
              transform: translate(-45%);
              margin: 0;
              white-space: nowrap;
              color: #333;
              font-size: 13px;
              font-weight: 400;
            }
          }
        }
      }
    }
  }
}
</style>
